import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import { Breadcrumb, CounterInput, PopUpModal, Select, TextInput, Title } from "../../Components/Atoms";
import PATHS from "../../Routes/paths";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getAllDealers, saveShipmentRequest } from "../../APIs";
import { Button } from "@chakra-ui/react";
import { CircledCheckIcon } from "../../Assets/images/svgs";
import { DEV_TYPE_VALUES, DEV_TYPES, DEVICE_TYPES } from "../../Library/constants";
import { StoreContext } from "../../Library/contexts";

const selectedDealerKeyValDetails = [
  { label: "Dealer Name", key: "nm" },
  { label: "Contact Person Name", key: "dnm" },
  { label: "Contact Number", key: "mob" },
  { label: "Shipping Address", key: "add" },
]

const ShippingDetails = () => {
  const [ searchParams ] = useSearchParams();
  const ORDER_ID = useRef(searchParams.get("idx"));
  const navigate = useNavigate();

  const [ dealers, setDealers ] = useState([]);
  const [ selectedDealer, setSelectedDealer ] = useState(0);
  const [ selectedDevice, setSelectedDevice ] = useState(0);
  const [ selectedQuantity, setSelectedQuantity ] = useState(1);
  const [ error, setError ] = useState("");
  const [ dealersDataMap, setDealersDataMap ] = useState({});
  const [ showSuccessModal, setShowSuccessModal ] = useState(false);
  const [ devTypeOptions, setDevTypeOptions ] = useState([]);
  const { constants } = useContext(StoreContext);

  useEffect(() => {
    const devCounts = constants.wallet.batWiseCount;
    const updatedOptions = DEVICE_TYPES.map(device => ({
      ...device,
      count: devCounts[DEV_TYPE_VALUES[device.label]] || 0
    }));

    setDevTypeOptions(updatedOptions);
  }, [constants.wallet.batWiseCount]);

  const breadcrumbPaths = [
    { idx: 1, name: "Shipments", link: PATHS.SHIPMENT_OVERVIEW },
    { idx: 2, name: "Request Shipment", isCurrentPage: true },
  ];

  const handleMenuClick = () => {
    if (!dealers || !dealers.length) {
      getAllDealers(null, (err, data) => {
        if (err) console.error(err);
        else {
          data.forEach(dealer => {
            dealer.label = dealer.nm;
            dealer.value = dealer.idx;
          });

          setDealers(data)
        };
      });
    }
  }

  const handleQuantityChange = (qty) => {
    setError("");
    setSelectedQuantity(qty);
  }

  const saveShipmentDetails = () => {
    setError("");

    if (!selectedDealer || !selectedQuantity || !selectedDevice) {
      return setError(`Please select ${(!selectedDealer && "dealer") || (!selectedDevice && "device") || (!selectedQuantity && "quantity")}`);
    }

    let shipmentDataToSend = {
      dlrId: selectedDealer,
      devcnt: selectedQuantity,
      batTyp: selectedDevice,
    };

    saveShipmentRequest(shipmentDataToSend, (err, data) => {
      if (err) {
        console.error(err);
        try {
          let error = JSON.parse(err);
          setError(error.data);
        } catch (e) {
          console.error(e);
        }
      }
      else {
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate(`${PATHS.SHIPMENT_OVERVIEW}/${PATHS.ORDER_DETAIL}?shipId=${data.orderId}`);
        }, 2000);
      }
    });
  }

  const handleDealerSelect = (dlrId) => {
    setSelectedDealer(dlrId);
    setError("");

    getAllDealers(dlrId, (err, data) => {
      if (err) console.error(err);
      else {
        setDealersDataMap(oldState => {
          return {
            ...oldState,
            [dlrId]: data
          };
        });
      }
    });
  }

  const getSuccessModalBody = () => {
    return (
      <div className="order-placed-modal-msg">
        <CircledCheckIcon />
        <p>Shipment Requested Successfully!</p>
      </div>
    );
  }

  return (
    <section className="panel-main">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className="shipping-details-container">
        <Title variant="lg" fixed>Shipping Details</Title>

        <div className="shipping-details-form-container">
          <label>
            <p>Dealership Name</p>
            <Select
              menuButtonClick={handleMenuClick}
              selected={selectedDealer}
              defaultOption="Select Dealer"
              onChange={handleDealerSelect}
              options={dealers}
              width={"100%"}
              menuButtonClass={`select-dealer-input ${selectedDealer ? "selected" : ""}`}
              menuListClass={"select-dealer-menu-list"}
            />
          </label>

          { dealersDataMap[selectedDealer] && dealersDataMap[selectedDealer].idx ? <div className="selected-dealer-details">
            { selectedDealerKeyValDetails.map(detail => {
              let dealerData = dealersDataMap[selectedDealer];
              return (
                <label>
                  { detail.label }:
                  <p>{ dealerData[detail.key] }</p>
                </label>
              )
            }) }
          </div> : null}

          <label>
            <p>Device Type</p>
            <Select
              selected={selectedDevice}
              defaultOption="Select Device Type"
              onChange={devId => setSelectedDevice(devId)}
              options={devTypeOptions}
              width={"100%"}
              menuButtonClass={`select-dealer-input ${selectedDevice ? "selected" : ""}`}
              menuListClass={"select-dealer-menu-list"}
            />
          </label>

          <label className="qty-counter">
            <p>Device Quantity</p>
            <CounterInput
              counterContainer="counter-input"
              counterButton="counter-button"
              counterDisplay="counter-display"
              onChange={handleQuantityChange}
              minValue={1}
            />

            {selectedDevice ? <p className="dev-stock-label">
              {`${DEV_TYPES[selectedDevice]} in stock:`}
              <span>{constants.wallet.batWiseCount[selectedDevice] || 0}</span>
            </p> : null}
          </label>
        </div>
      </div>

      <div className="confirm-shipment-btn-container">
        <p className="shipment-form-err-msg">{error}</p>
        <Button className={`confirm-shipment-btn ${(selectedDealer && selectedQuantity) ? "enabled" : ""}`} onClick={saveShipmentDetails} disabled={!selectedDealer || !selectedQuantity}>
          Confirm Shipment
        </Button>
      </div>

      <PopUpModal open={showSuccessModal} modalMsg={getSuccessModalBody()} onModalClose={() => {}} darken />
    </section>
  )
}

export default ShippingDetails
